<template>
  <div class="loginPage">
    <div class="form_wrap flex-between">
      <div class="new_box">
        <swiper :options="swiperOption" ref="mySwiper">
          <swiper-slide>
            <div class="tit">Help you create personalized products</div>
            <div class="sub_tit">
              Quickly generate and test market response & Quick response
              dropshipping service
            </div>
            <div class="main_box flex-rowl">
              <div class="img">
                <el-image
                  style="width: 100%; height: 100%"
                  :src="require('@/assets/images/login_news01.png')"
                ></el-image>
              </div>
              <div class="txt">
                <p>
                  We have integrated the manufacturers and supply chains of more
                  than 16,000 daily consumer goods, and built a complete service
                  system from design analysis, raw materials, production
                  execution, and transportation delivery in a matrix-style
                  division of labor and cooperation model to meet your needs for
                  product production and supply.
                </p>
              </div>
            </div>
            <div class="more">
              <span class="flex-between" @click="showLogin"
                >meet more? <i class="iconfont icon-sanjiaojiantoushang"></i
              ></span>
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="tit">Help you create personalized products</div>
            <div class="sub_tit">
              Quickly generate and test market response & Quick response
              dropshipping service
            </div>
            <div class="main_box flex-rowl">
              <div class="img">
                <el-image
                  style="width: 100%; height: 100%"
                  :src="require('@/assets/images/login_news01.png')"
                ></el-image>
              </div>
              <div class="txt">
                <p>
                  We have integrated the manufacturers and supply chains of more
                  than 16,000 daily consumer goods, and built a complete service
                  system from design analysis, raw materials, production
                  execution, and transportation delivery in a matrix-style
                  division of labor and cooperation model to meet your needs for
                  product production and supply.
                </p>
              </div>
            </div>
            <div class="more">
              <span class="flex-between" @click="showLogin"
                >meet more? <i class="iconfont icon-sanjiaojiantoushang"></i
              ></span>
            </div>
          </swiper-slide>
        </swiper>
        <div class="swiper-pagination"></div>
      </div>
      <div class="form_box">
        <div class="title flex-colc">
          <div class="logo">
            <el-image
              style="width: 100%; height: 100%"
              :src="require('@/assets/images/publice_logo.png')"
            ></el-image>
          </div>
          <div class="sub_tit">[ Ten Thousand Kind of Supply Chain ]</div>
        </div>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="95px"
          label-position="left"
          class="demo-ruleForm"
        >
          <el-form-item prop="username" class="flex-rowc">
            <el-input
              v-model="ruleForm.username"
              placeholder="YOUR ID"
            ></el-input>
          </el-form-item>
          <el-form-item prop="pwd" class="form-item flex-rowc">
            <el-input v-model="ruleForm.pwd" placeholder="PASSWORD"></el-input>
            <div class="input_btn" @click="handleRegister">Forgot?</div>
          </el-form-item>
          <div class="verify_wrap flex-rowl">
            <div class="verify-input flex-rowc">
              <!-- <span style="color: #EA3C2A; font-weight: bold;"></span> -->
              <el-form-item label="" prop="verifyCode" label-width="70px">
                <el-input
                  v-model="ruleForm.verifyCode"
                  placeholder="Verification code"
                  @keyup.enter.native="submitForm('ruleForm')"
                ></el-input>
              </el-form-item>
            </div>
            <VerifyCode
              key="verify-code-1"
              @code-changed="handleCodeChanged1"
            />
          </div>
          <div
            class="submit flex-rowc"
            @click="submitForm('ruleForm')"
            v-loading.fullscreen.lock="fullscreenLoading"
          >
            LOG-IN
          </div>
        </el-form>
        <div class="register flex-rowc" @click="handleRegister">
          <p>Register | Be a Cooperative Partner</p>
        </div>
      </div>
    </div>

    <!-- 栏目 start -->
    <div class="shop_category_wrap" :class="{ 'top-reached': isTopReached }">
      <swiper :options="swiperOption1" ref="mySwiper">
        <swiper-slide v-for="(item, index) in commodityList" :key="index">
          <div class="shop_category_main flex-rowl">
            <div class="thumb">
              <el-image
                style="width: 100%; height: 100%"
                :src="'https://shop.winksshowp.com/Upload/' + item.img"
                fit="cover"
              ></el-image>
            </div>
            <div class="content">
              <h1>{{ item.mul_labelname }}</h1>
              <p>{{ item.mul_labelcont }}</p>
            </div>
          </div>
        </swiper-slide>
      </swiper>
      <div class="swiper-button-prev commodity_wrap_swiper-prev">
        <i class="iconfont icon-right"></i>
      </div>
      <div class="swiper-button-next commodity_wrap_swiper-next">
        <i class="iconfont icon-right"></i>
      </div>
    </div>
    <!-- 栏目 end -->

    <!-- 商品列表 start -->
    <div class="commodity_container">
      <div
        class="commodity_wrap"
        v-for="(item, index) in dataList"
        :key="index"
      >
        <div class="commodity_head flex-rowl">
          <div
            class="head_classify flex-rowl"
            v-for="(itenLabel, indexLabel) in item.childs2.slice(0, 2)"
            :key="indexLabel"
          >
            <span class="iconfont icon-gengduo"></span>
            <p>{{ itenLabel.mul_labelname }}</p>
          </div>
          <div
            class="head_label flex-rowl"
            v-if="item.cmkeysids_onelist && item.cmkeysids_onelist.length > 0"
          >
            <span></span>
            <p
              v-for="(itemCmkey, indexCmkey) in item.cmkeysids_onelist"
              :key="indexCmkey"
              @click="showLogin"
            >
              # {{ itemCmkey.labelname }}
            </p>
          </div>
        </div>
        <div class="commodity_list flex-rowl">
          <div class="commodity_list_item_main">
            <template v-if="item.ams_shop_label_banner.length > 0">
              <div class="thumb">
                <el-image
                  style="width: 100%; height: 100%"
                  :src="
                    'https://shop.winksshowp.com/Upload/' +
                    item.ams_shop_label_banner[0].pic
                  "
                  fit="cover"
                ></el-image>
              </div>
              <div class="content">
                <div class="tit">{{ item.ams_shop_label_banner[0].topic }}</div>
                <div class="other flex-rowl">
                  <div class="more_arr">
                    <span class="iconfont icon-jiantou"></span>
                  </div>
                  <div class="more">
                    <span class="flex-between" @click="showLogin"
                      >meet more?
                      <i class="iconfont icon-sanjiaojiantoushang"></i
                    ></span>
                  </div>
                </div>
              </div>
            </template>
          </div>
          <div
            class="commodity_list_item"
            v-for="(itemChild, indexChild) in item.goodsList"
            :key="indexChild"
          >
            <div class="thumb">
              <el-image
                style="width: 100%; height: 100%"
                :src="itemChild.banner"
                fit="cover"
              ></el-image>
              <div class="label_group flex-colc">
                <p
                  v-for="(itemLabel, indexLabel) in itemChild.labelslist"
                  :key="indexLabel"
                >
                  # {{ itemLabel.mul_labelcont }}
                </p>
              </div>
            </div>
            <div class="content">
              <div class="tit">{{ itemChild.mul_commodityname }}</div>
              <div class="brand flex-rowl">
                <span class="iconfont icon-peihuo"></span>
                {{
                  itemChild.qyename ? itemChild.qyename : itemChild.qy_accountid
                }}
              </div>
              <div class="txt">400+ bought Past 30 days</div>
              <div class="grade flex-rowl">
                <p>Buyers' Evaluate：</p>
                <div class="leval_group flex-rowl">
                  <span
                    v-for="(itemScore, indexScore) in 5"
                    :key="indexScore"
                    class="iconfont icon-pingfen1"
                    :class="{
                      active: indexScore < item.countryScore,
                      ['score_' + itemScore]: true,
                    }"
                  ></span>

                  <!-- <span class="iconfont icon-pingfen1 active"></span>
                  <span class="iconfont icon-pingfen1 active"></span>
                  <span class="iconfont icon-pingfen1"></span>
                  <span class="iconfont icon-pingfen1"></span> -->
                </div>
              </div>
              <div class="price flex-rowl">
                <div class="symbol flex-colc">
                  <span>Reference</span>
                  <span class="unit">({{ COUNTRY.moneyslog }}） : </span>
                </div>
                <!-- 20.<span>7</span> -->
                <div class="num" v-html="itemChild.mulstr_price"></div>
              </div>

              <!-- 价格组合 -->
              <div class="price_group flex-rowl">
                <div
                  class="label flex-rowl"
                  @click="togglePriceDetail(index, indexChild)"
                >
                  <p>Retail</p>
                  <p>Batch</p>
                  <p>Big Orders</p>
                </div>
                <!-- 价格详情 -->
                <transition name="slide">
                  <div
                    class="price_detail"
                    v-if="itemChild.isPriceDetailVisible"
                  >
                    <div class="head flex-between">
                      <p>Reference Price</p>
                      <div
                        class="close flex-rowl"
                        @click="togglePriceDetail(index, indexChild)"
                      >
                        <span class="iconfont icon-dangeyichuicon"></span>
                      </div>
                    </div>
                    <div class="price_item">
                      <div class="txt1 flex-between">
                        <p>Retail</p>
                        <div class="num">1 Piece</div>
                      </div>
                      <div class="txt2 flex-rowl">
                        <div class="symbol flex-rowl">
                          ({{ COUNTRY.moneyslog }})：
                        </div>
                        <div class="num flex-rowl">
                          <span>{{ itemChild.mul_price }}</span
                          >/Per
                        </div>
                      </div>
                    </div>
                    <div class="price_item">
                      <div class="txt1 flex-between">
                        <p>Batch</p>
                        <div class="num">
                          ≥ <span>{{ itemChild.startnum2 }}</span> Piece
                        </div>
                      </div>
                      <div class="txt2 flex-rowl">
                        <div class="symbol flex-rowl">
                          ({{ COUNTRY.moneyslog }})：
                        </div>
                        <div class="num flex-rowl">
                          <span>{{ itemChild.mul_groupprice }}</span
                          >/Per
                        </div>
                      </div>
                    </div>
                    <div class="price_item">
                      <div class="txt1 flex-between">
                        <p>Big Orders</p>
                        <div class="num">
                          ≥ <span>{{ itemChild.startnum3 }}</span> Piece
                        </div>
                      </div>
                      <div class="txt2 flex-rowl">
                        <div class="symbol flex-rowl">
                          ({{ COUNTRY.moneyslog }})：
                        </div>
                        <div class="num flex-rowl">
                          <span>{{ itemChild.mul_pfprice }}</span
                          >/Per
                        </div>
                      </div>
                    </div>
                  </div>
                </transition>
              </div>
            </div>
          </div>
        </div>
        <div class="commodity_more" @click="showLogin"></div>
      </div>
    </div>
    <!-- 商品列表 end -->

    <div class="colmun_one">
      <swiper :options="swiperOption2" ref="mySwiper">
        <swiper-slide>
          <div class="colmun_wrap flex-between">
            <div class="img">
              <el-image
                style="width: 100%; height: 100%"
                :src="require('@/assets/images/login_column_one01.png')"
              ></el-image>
            </div>
            <div class="content">
              <div class="tit">
                Galaxy Z Fold 6 <br />
                New Product Release of SAMSUNG
              </div>
              <p>
                As a horizontal folding iteration product, the Samsung Galaxy Z
                Fold 6 still continues the design style of its predecessor, but
                is lighter and thinner overall. The folded thickness is reduced
                from 13.4mm of the previous generation to 12.1mm, and the
                unfolded thickness is controlled at 5.6mm. The weight is reduced
                from 254g of the previous generation to 239g. The current folded
                dimensions are 68.1×153.5×12.1mm, and the unfolded dimensions
                are 132.6×153.5×5.6mm.
              </p>
              <div class="more">
                <span class="flex-between" @click="showLogin"
                  >meet more? <i class="iconfont icon-sanjiaojiantoushang"></i
                ></span>
              </div>
            </div>
          </div>
        </swiper-slide>
      </swiper>
      <div class="swiper-button-prev colmun_one_swiper-prev"></div>
      <div class="swiper-button-next colmun_one_swiper-next"></div>
    </div>

    <div class="column_two">
      <div class="column_list flex-rowc">
        <div class="column_item">
          <div class="thumb">
            <el-image
              style="width: 100%; height: 100%"
              :src="require('@/assets/images/login_column_two01.png')"
            ></el-image>
          </div>
          <div class="tit">Join Our Shared Warehouse Cooperation Service</div>
          <div class="txt">
            Maximize the use of your idle storage resources to Create value
          </div>
        </div>
        <div class="column_item">
          <div class="thumb">
            <el-image
              style="width: 100%; height: 100%"
              :src="require('@/assets/images/login_column_two02.png')"
            ></el-image>
          </div>
          <div class="tit">Upload the hot products you found</div>
          <div class="txt">
            Tell us what kind of products you want so that we can cooperate
            better
          </div>
        </div>
        <div class="column_item">
          <div class="thumb">
            <el-image
              style="width: 100%; height: 100%"
              :src="require('@/assets/images/login_column_two03.png')"
            ></el-image>
          </div>
          <div class="tit">
            Find supply chain merchants for your product selection center
            through us
          </div>
          <div class="txt">
            We can still cooperate smoothly in the market areas of traditional
            models
          </div>
        </div>
        <div class="column_item">
          <div class="thumb">
            <el-image
              style="width: 100%; height: 100%"
              :src="require('@/assets/images/login_column_two04.png')"
            ></el-image>
          </div>
          <div class="tit">
            You can also sell products to China & Vietnam Thailand Malaysia
            Southeast Asian countries through us
          </div>
          <div class="txt">
            Rapid response Chinese social media resources and operation services
            to help brand landing and product sales
          </div>
        </div>
      </div>
      <div class="know_more flex-between">
        <div class="txt1 flex-rowc">
          <i class="iconfont icon-xiangqing"></i> Know more about us
        </div>
        <div class="txt2 flex-rowc" @click="handleRegister">
          Register | Be a Cooperative Partner
        </div>
      </div>
    </div>

    <!-- 登录弹窗 -->
    <el-dialog
      :visible.sync="showLoginDialog"
      :show-close="false"
      custom-class="custom-dialog"
    >
      <template #title>
        <div class="custom-header flex-rowc">
          <div class="logo">
            <el-image
              style="width: 100%; height: 100%"
              :src="require('@/assets/images/publice_logo.png')"
            ></el-image>
          </div>
        </div>
      </template>
      <div class="content flex-rowc">
        <div class="new_box">
          <div class="txt">
            <h1 class="mb_5">Please Log-in</h1>
            <p>and then experience more features</p>
          </div>

          <div class="txt">
            <p class="mb_5">
              If you register as a user,<br />
              please complete the
            </p>
            <h1>Registration Process</h1>
          </div>
          <div class="txt">
            <p class="mb_5">
              Currently over 60000 users<br />
              have chosen to be the
            </p>
            <h1>WINK SSHOWP USER.</h1>
          </div>
        </div>
        <div class="form_box">
          <el-form
            :model="ruleForm1"
            :rules="rules1"
            ref="ruleForm1"
            label-width="95px"
            label-position="left"
            class="demo-ruleForm"
          >
            <el-form-item prop="username" class="flex-rowc">
              <el-input
                v-model="ruleForm1.username"
                placeholder="YOUR ID"
              ></el-input>
            </el-form-item>
            <el-form-item prop="pwd" class="form-item flex-rowc">
              <el-input
                v-model="ruleForm1.pwd"
                placeholder="PASSWORD"
              ></el-input>
              <div class="input_btn" @click="handleRegister">Forgot?</div>
            </el-form-item>
            <div class="verify_wrap flex-rowl">
              <div class="verify-input flex-rowc">
                <!-- <span style="color: #EA3C2A; font-weight: bold;"></span> -->
                <el-form-item label="" prop="verifyCode" label-width="70px">
                  <el-input
                    v-model="ruleForm1.verifyCode"
                    placeholder="Verification code"
                    @keyup.enter.native="submitForm('ruleForm1')"
                  ></el-input>
                </el-form-item>
              </div>
              <VerifyCode
                key="verify-code-2"
                @code-changed="handleCodeChanged2"
              />
            </div>
            <div
              class="submit flex-rowc"
              @click="submitForm('ruleForm1')"
              v-loading.fullscreen.lock="fullscreenLoading"
            >
              LOG-IN
            </div>
          </el-form>
          <div class="register flex-rowc" @click="handleRegister">
            <p>Register | Be a Cooperative Partner</p>
          </div>
        </div>
        <div class="custom-close" @click="handleDialog">
          <i class="iconfont icon-jujueweituo"></i>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// 引入文件
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import { mapState } from "vuex";
import {
  specialUserLogin,
  getCommondityLabel,
  getCommonditySpecial,
} from "../api/api";
import VerifyCode from "../components/VerifyCode.vue"; // 引入 VerifyCode 组件
export default {
  name: "login",
  //import引入的组件需要注入到对象中才能使用
  components: { swiper, swiperSlide, VerifyCode },
  data() {
    var validatorCode = (rule, value, callback) => {
      if (value == "") {
        callback(new Error("Verification code"));
      } else if (value != this.verifyCode1) {
        callback(new Error("Verification code"));
      } else {
        callback();
      }
    };

    var validatorCode1 = (rule, value, callback) => {
      if (value == "") {
        callback(new Error("Verification code"));
      } else if (value != this.verifyCode2) {
        callback(new Error("Verification code"));
      } else {
        callback();
      }
    };
    return {
      fullscreenLoading: false,

      verifyCode1: "", // 验证码1
      verifyCode2: "", // 验证码2

      ruleForm: {
        username: "",
        pwd: "",
        countryid: "",
        verifyCode: "",
      },
      rules: {
        username: [
          { required: true, message: "YOUR ID", trigger: "blur" },
          // { min: 4, max: 20, message: "请输入4~20位用户名", trigger: "blur" },
        ],
        pwd: [
          { required: true, message: "PASSWORD", trigger: "blur" },
          // { min: 6, max: 18, message: "请输入6~18位密码", trigger: "blur" },
        ],
        verifyCode: [
          { required: true, validator: validatorCode, trigger: "blur" },
        ],
      },

      ruleForm1: {
        username: "",
        pwd: "",
        countryid: "",
        verifyCode: "",
      },
      rules1: {
        username: [
          { required: true, message: "YOUR ID", trigger: "blur" },
          // { min: 4, max: 20, message: "请输入4~20位用户名", trigger: "blur" },
        ],
        pwd: [
          { required: true, message: "PASSWORD", trigger: "blur" },
          // { min: 6, max: 18, message: "请输入6~18位密码", trigger: "blur" },
        ],
        verifyCode: [
          { required: true, validator: validatorCode1, trigger: "blur" },
        ],
      },

      isShow: false,

      swiperOption: {
        autoplay: {
          //自动开始
          delay: 2000, //时间间隔
          disableOnInteraction: false, //*手动操作轮播图后不会暂停*
        },
        loop: false,
        initialSlide: 0, //初始化页码
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      },
      swiperOption1: {
        slidesPerView: 5,
        autoplay: {
          //自动开始
          delay: 2000, //时间间隔
          disableOnInteraction: false, //*手动操作轮播图后不会暂停*
        },
        loop: false,
        initialSlide: 0, //初始化页码
        prevButton: ".commodity_wrap_swiper-prev",
        nextButton: ".commodity_wrap_swiper-next",
      },
      swiperOption2: {
        autoplay: {
          //自动开始
          delay: 2000, //时间间隔
          disableOnInteraction: false, //*手动操作轮播图后不会暂停*
        },
        loop: false,
        initialSlide: 0, //初始化页码
        prevButton: ".colmun_one_swiper-prev",
        nextButton: ".colmun_one_swiper-next",
      },

      // 原有的数据
      isTopReached: false,

      // 商品分类
      commodityList: [],

      params: {
        Page: "1",
        PageSize: 4,
        typeid: "",
        keyword: "",
        istop: "",
        comtype: "",
        scorewide: "",
        isintro: "", // 推荐 1 非推荐的 0， 留空则显示全部
        labels: "", // 可以输入特定标签，比如 爆款 新品
        ordertype: "", // 1 综合排序 2价格升序  3 价格降序 4积分升序  5积分降序
        brandid: "",
        commoditystate: 1, // 1 上架 0 下架 2 全部 留空为上架
        qyid: "",
        countryid: "", // 根据国家屏蔽特定的企业 countryid从接口549获取
        fav_openid: "",
        labelid: "",
        labelid2: "",
        labelid3: "",
      },
      dataList: [],
      showLoginDialog: false,
    };
  },
  computed: {
    ...mapState(["COUNTRY"]),
  },
  created() {},
  mounted() {
    let { COUNTRY } = this.$store.state;

    this.params.countryid = COUNTRY.countryid ? parseInt(COUNTRY.countryid) : 1;
    this.getCommondityLabel();
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleMultilingualName(type, dataList, key1, key2) {
      let { countryid } = this.COUNTRY;
      dataList.forEach((v) => {
        // 根据不同国家countryid获取评分
        if (v.ams_shop_commodity_area && v.ams_shop_commodity_area.length > 0) {
          v.ams_shop_commodity_area.forEach((v1) => {
            if (v1.countryid == countryid) {
              v.countryScore = v1.average;
            }
          });
        }

        if (countryid == 1) {
          v[`mul_${key1}`] = v[key1];
          if (key2) {
            v[`mul_${key2}`] = v[key2];
          }

          // 处理商品数据
          if (type == "shop") {
            // 处理 labelslist 数组
            if (v.labelslist && Array.isArray(v.labelslist)) {
              v.labelslist = v.labelslist.map((label) => {
                label.mul_labelcont = label.labelcont;
                return label;
              });
            }
            // 价格
            v.mul_price = v.price;
            v.mul_groupprice = v.groupprice;
            v.mul_pfprice = v.pfprice;
            // 处理价格格式
            v.mulstr_price = formatPrice(v.mul_price);
          }
          // 处理商品分类
          if (type == "shopLabel") {
            if (v.childs2 && Array.isArray(v.childs2)) {
              v.childs2.forEach((child2) => {
                child2.mul_labelname = child2.labelname;
                if (child2.childs3 && Array.isArray(child2.childs3)) {
                  child2.childs3.forEach((child3) => {
                    child3.mul_labelname = child3.labelname;
                  });
                }
              });
            }
          }
        } else if (countryid == 8) {
          // 英文
          v[`mul_${key1}`] = v[key1 + "_e"] ? v[key1 + "_e"] : v[key1];
          if (key2) {
            v[`mul_${key2}`] = v[key2 + "_e"] ? v[key2 + "_e"] : v[key2];
          }

          // 处理商品数据
          if (type == "shop") {
            // 处理 labelslist 数组
            if (v.labelslist && Array.isArray(v.labelslist)) {
              v.labelslist = v.labelslist.map((label) => {
                label.mul_labelcont = label.labelcont_e
                  ? label.labelcont_e
                  : label.labelcont;
                return label;
              });
            }
            // 价格
            v.mul_price = v.ams_shop_commodity_exrate.ame_price
              ? v.ams_shop_commodity_exrate.ame_price
              : "";
            v.mul_groupprice = v.ams_shop_commodity_exrate.ame_tuan
              ? v.ams_shop_commodity_exrate.ame_tuan
              : "";
            v.mul_pfprice = v.ams_shop_commodity_exrate.ame_tuan_base
              ? v.ams_shop_commodity_exrate.ame_tuan_base
              : "";

            // 处理价格格式
            v.mulstr_price = formatPrice(v.mul_price);
          }

          // 处理商品分类
          if (type == "shopLabel") {
            if (v.childs2 && Array.isArray(v.childs2)) {
              v.childs2.forEach((child2) => {
                child2.mul_labelname = child2.labelname_e
                  ? child2.labelname_e
                  : child2.labelname;
                if (child2.childs3 && Array.isArray(child2.childs3)) {
                  child2.childs3.forEach((child3) => {
                    child3.mul_labelname = child3.labelname_e
                      ? child3.labelname_e
                      : child3.labelname;
                  });
                }
              });
            }
          }
        } else if (countryid == 2) {
          // 俄语
          v[`mul_${key1}`] = v[key1 + "_m"]
            ? v[key1 + "_m"]
            : v[key1 + "_e"]
            ? v[key1 + "_e"]
            : v[key1];
          if (key2) {
            v[`mul_${key2}`] = v[key2 + "_m"]
              ? v[key2 + "_m"]
              : v[key2 + "_e"]
              ? v[key2 + "_e"]
              : v[key2];
          }

          // 处理商品数据
          if (type == "shop") {
            // 处理 labelslist 数组
            if (v.labelslist && Array.isArray(v.labelslist)) {
              v.labelslist = v.labelslist.map((label) => {
                label.mul_labelcont = label.labelcont_m
                  ? label.labelcont_m
                  : label.labelcont_e
                  ? label.labelcont_e
                  : label.labelcont;
                return label;
              });
            }
            // 价格
            v.mul_price = v.ams_shop_commodity_exrate.lu_price
              ? v.ams_shop_commodity_exrate.lu_price
              : "";
            v.mul_groupprice = v.ams_shop_commodity_exrate.lu_tuan
              ? v.ams_shop_commodity_exrate.lu_tuan
              : "";
            v.mul_pfprice = v.ams_shop_commodity_exrate.lu_tuan_base
              ? v.ams_shop_commodity_exrate.lu_tuan_base
              : "";

            // 处理价格格式
            v.mulstr_price = formatPrice(v.mul_price);
          }

          // 处理商品分类
          if (type == "shopLabel") {
            if (v.childs2 && Array.isArray(v.childs2)) {
              v.childs2.forEach((child2) => {
                child2.mul_labelname = child2.labelname_m
                  ? child2.labelname_m
                  : child2.labelname_e
                  ? child2.labelname_e
                  : child2.labelname;
                if (child2.childs3 && Array.isArray(child2.childs3)) {
                  child2.childs3.forEach((child3) => {
                    child3.mul_labelname = child3.labelname_m
                      ? child3.labelname_m
                      : child3.labelname_e
                      ? child3.labelname_e
                      : child3.labelname;
                  });
                }
              });
            }
          }
        } else if (countryid == 4) {
          // 越语
          v[`mul_${key1}`] = v[key1 + "_y"]
            ? v[key1 + "_y"]
            : v[key1 + "_e"]
            ? v[key1 + "_e"]
            : v[key1];
          if (key2) {
            v[`mul_${key2}`] = v[key2 + "_y"]
              ? v[key2 + "_y"]
              : v[key2 + "_e"]
              ? v[key2 + "_e"]
              : v[key2];
          }

          // 处理商品数据
          if (type == "shop") {
            // 处理 labelslist 数组
            if (v.labelslist && Array.isArray(v.labelslist)) {
              v.labelslist = v.labelslist.map((label) => {
                label.mul_labelcont = label.labelcont_y
                  ? label.labelcont_y
                  : label.labelcont_e
                  ? label.labelcont_e
                  : label.labelcont;
                return label;
              });
            }
            // 价格
            v.mul_price = v.ams_shop_commodity_exrate.yue_price
              ? v.ams_shop_commodity_exrate.yue_price
              : "";
            v.mul_groupprice = v.ams_shop_commodity_exrate.yue_tuan
              ? v.ams_shop_commodity_exrate.yue_tuan
              : "";
            v.mul_pfprice = v.ams_shop_commodity_exrate.yue_tuan_base
              ? v.ams_shop_commodity_exrate.yue_tuan_base
              : "";
            // 处理价格格式
            v.mulstr_price = formatPrice(v.mul_price);
          }

          // 处理商品分类
          if (type == "shopLabel") {
            if (v.childs2 && Array.isArray(v.childs2)) {
              v.childs2.forEach((child2) => {
                child2.mul_labelname = child2.labelname_y
                  ? child2.labelname_y
                  : child2.labelname_e
                  ? child2.labelname_e
                  : child2.labelname;
                if (child2.childs3 && Array.isArray(child2.childs3)) {
                  child2.childs3.forEach((child3) => {
                    child3.mul_labelname = child3.labelname_y
                      ? child3.labelname_y
                      : child3.labelname_e
                      ? child3.labelname_e
                      : child3.labelname;
                  });
                }
              });
            }
          }
        }
      });
      return dataList;

      // 定义处理价格格式的函数
      function formatPrice(price) {
        const priceStr = String(price);
        const parts = priceStr.split(".");
        if (parts.length > 1) {
          return `${parts[0]}.<span>${parts[1]}</span>`;
        }
        return priceStr;
      }
    },

    // 获取商品分类
    async getCommondityLabel() {
      const loading = this.$loading({
        lock: true,
        text: "加载中，请稍后",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.9)",
      });
      try {
        const res = await getCommondityLabel();
        // 筛选五个分类：id=21545efbac6545f89ac8ccf39f25b2ed（鞋袜）、216aeab8f3d14325b1b80f6cfe31b46e（美妆&护肤）、e15491058139436d87c2e71ff04a30a1（电子&数码产品）、e97d25cf40f94f059f017d82310bbd60（珠宝配饰）、f23677a3e21742ba8ef11c3b1ea761ab（服饰穿搭）
        let filterArr = res.filter(
          (v) =>
            v.id == "21545efbac6545f89ac8ccf39f25b2ed" ||
            v.id == "216aeab8f3d14325b1b80f6cfe31b46e" ||
            v.id == "e15491058139436d87c2e71ff04a30a1" ||
            v.id == "e97d25cf40f94f059f017d82310bbd60" ||
            v.id == "f23677a3e21742ba8ef11c3b1ea761ab"
        );

        // 不同国家选择多语言
        let MultilingualArr = this.handleMultilingualName(
          "shopLabel",
          filterArr,
          "labelname",
          "labelcont"
        );
        console.log(MultilingualArr, "====MultilingualArr");

        this.commodityList = MultilingualArr;
        this.dataList = MultilingualArr;

        // 每一个分类对应商品列表，this.dataList遍历数据，通过id来修改参数params.labelid，然后获取商品列表，并且新增到值goodsList中
        for (let i = 0; i < MultilingualArr.length; i++) {
          const v = MultilingualArr[i];
          this.params.labelid = v.id;
          await this.initData();
          await new Promise((resolve) => setTimeout(resolve, 50));
        }

        // 删除 goodsList 为空的数据
        this.dataList = this.dataList.filter(
          (item) => item.goodsList && item.goodsList.length > 0
        );

        // 分类对应的商品全部加载完整以后loading设置为false
        loading.close();
      } catch (error) {
        console.error("获取商品分类失败:", error);
      } finally {
        this.loading = false;
      }
    },

    // 获取商品列表
    async initData() {
      let { params } = this;
      try {
        const res = await getCommonditySpecial(params);
        // 假设 res 是一个包含商品列表的数组
        if (res.list && res.list.length > 0) {
          // 不同国家选择多语言
          let MultilingualArr = this.handleMultilingualName(
            "shop",
            res.list,
            "commodityname"
          );
          // 查找当前分类对应的商品列表
          let category = this.commodityList.find(
            (c) => c.id === params.labelid
          );
          if (category) {
            // 如果分类存在，则将商品列表添加到该分类的 goodsList 属性中
            if (!category.goodsList) {
              category.goodsList = [];
            }
            category.goodsList = category.goodsList.concat(MultilingualArr);
          }
        }
      } catch (error) {
        console.error("获取商品列表失败:", error);
      }
    },

    // 原有的方法
    handleScroll() {
      const colmunThree = document.querySelector(".shop_category_wrap");
      const commodity_container = document.querySelector(
        ".commodity_container"
      );
      if (colmunThree) {
        const rect = colmunThree.getBoundingClientRect();
        const rect1 = commodity_container.getBoundingClientRect();
        // 如果元素已固定，且顶部距离大于 30px，取消固定
        if (this.isTopReached && rect1.top > 30) {
          this.isTopReached = false;
        }
        // 如果元素未固定，且顶部距离小于等于 0，固定元素
        else if (!this.isTopReached && rect.top <= 0) {
          this.isTopReached = true;
        }
      }
    },

    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.fullscreenLoading = true;
          // 根据表单名称选择对应的数据
          const formData =
            formName === "ruleForm" ? this.ruleForm : this.ruleForm1;
          const { username, pwd } = formData;
          const params = {
            username,
            pwd,
            countryid: this.COUNTRY.countryid,
          };
          this.userSubmit(params);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    // 登录接口
    userSubmit(params) {
      specialUserLogin(params).then((res) => {
        if (res.result == "True") {
          let message = this.$message({
            message: this.$t("Login successful"),
            center: true,
            type: "success",
          });
          this.$store.commit("updateToken", res.token);
          this.fullscreenLoading = false;
          setTimeout(() => {
            this.$router.push("/home");
            message.close();
          }, 1500);
        } else {
          this.$message.error(
            res.msg == "登录失败"
              ? this.$t("Account or password error")
              : this.$t(
                  "The function is temporarily unavailable, please try again later"
                )
          );
          this.fullscreenLoading = false;
        }
      });
    },

    handleRegister() {
      this.$router.push("/register");
    },

    handleCodeChanged1(code) {
      this.verifyCode1 = code;
    },
    handleCodeChanged2(code) {
      this.verifyCode2 = code;
    },

    togglePriceDetail(index, indexChild) {
      let { dataList } = this;
      const newDataList = [...dataList];
      const newGoodsList = [...newDataList[index].goodsList];
      newGoodsList[indexChild] = {
        ...newGoodsList[indexChild],
        isPriceDetailVisible: !newGoodsList[indexChild].isPriceDetailVisible,
      };
      newDataList[index] = {
        ...newDataList[index],
        goodsList: newGoodsList,
      };
      this.dataList = newDataList;
    },

    // 显示登录弹窗
    showLogin() {
      this.showLoginDialog = true;
      // 清空 rules 表单的校验
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.resetFields();
      }
    },
    // 登录弹窗
    handleDialog() {
      // 清空 rules1 表单的校验
      if (this.$refs.ruleForm1) {
        this.$refs.ruleForm1.resetFields();
      }
      this.showLoginDialog = false;
    },
  },
};
</script>
<style lang="less" scoped>
.loginPage {
  padding-top: 30px;
  box-sizing: border-box;
  background: #e7e8f0;
  .more {
    span {
      cursor: pointer;
      // background: url(../assets/images/login_more.png) no-repeat center;
      background-size: cover;
      width: 110px;
      height: 30px;
      background: #000000;
      border-radius: 45px;
      font-size: 12px;
      color: #fff;
      padding: 0 14px;
      box-sizing: border-box;
      .iconfont {
        font-size: 10px;
        transform: rotate(-90deg);
      }
    }
  }
  .form_box {
    width: 370px;
    height: 390px;
    background: rgba(255, 255, 255, 0.8);
    border-radius: 30px;
    .title {
      padding: 26px 0 16px;
      box-sizing: border-box;
      .logo {
        margin-bottom: 12px;
        width: 217px;
        height: 23px;
      }
      .sub_tit {
        font-size: 16px;
        color: #000000;
      }
    }
    /deep/.el-form-item {
      margin-bottom: 18px;
      .el-form-item__content {
        margin-left: 0 !important;
        width: 310px;
        height: 36px;
        line-height: 36px;
        .el-input__inner {
          border-radius: 45px;
          height: 100%;
        }
      }
    }
    /deep/.el-input {
      height: 100%;
    }

    .submit {
      width: 310px;
      height: 45px;
      border-radius: 45px;
      background: #000000;
      font-size: 16px;
      color: #ffffff;
      margin: auto;
      font-family: "MontserratRegular", sans-serif; /* 使用引入的字体 */
      letter-spacing: 1px;
      cursor: pointer;
    }
    .verify_wrap {
      width: 310px;
      margin: 0 auto 0.2rem;
      .verify-input {
        width: 150px;
        margin-right: 10px;
        /deep/ .el-form-item {
          width: 100%;
          margin-bottom: 0;
          .el-form-item__content {
            width: 100%;
          }
        }
      }
    }
    .form-item {
      position: relative;
      .input_btn {
        position: absolute;
        right: 0;
        top: 0;
        bottom: 0;
        font-size: 14px;
        color: #333333;
        cursor: pointer;
        padding: 0 20px;
      }
    }
    .register {
      width: 310px;
      margin: 10px auto 0;
      font-size: 16px;
      height: 45px;
      background: #fff;
      border-radius: 45px;
      cursor: pointer;
    }
  }
  .form_wrap {
    background: url(../assets/images/login_form_bg.png) no-repeat center;
    background-size: cover;
    height: 510px;
    padding: 0 280px;
    box-sizing: border-box;
    .new_box {
      width: 970px;
      height: 390px;
      background: rgba(255, 255, 255, 0.85);
      border-radius: 30px;
      padding: 30px 30px 0;
      box-sizing: border-box;
      color: #333333;
      position: relative;
      .tit {
        font-size: 26px;
      }
      .sub_tit {
        font-size: 18px;
        margin: 9px 0 23px;
      }
      .main_box {
        margin-bottom: 24px;
        .img {
          flex-shrink: 0;
          width: 360px;
          height: 190px;
          margin-right: 20px;
        }
        .txt {
          flex: 1;
          font-size: 18px;
          line-height: 26px;
        }
      }
      .swiper-pagination {
        left: 50%;
        transform: translateX(-50%);
        /deep/ .swiper-pagination-bullet-active {
          background: #f00139;
        }
        /deep/ .swiper-pagination-bullet {
          margin-right: 10px;
          &:last-child {
            margin-right: 0;
          }
        }
      }
    }
    .tip {
      padding-bottom: 20px;
      font-size: 12px;
      color: #333333;
      margin-top: 15px;
      font-family: "MontserratExtraLight", sans-serif; /* 使用引入的字体 */
      box-sizing: border-box;
      p {
        letter-spacing: 1px;
      }
      .img {
        margin-top: 8px;
      }
    }
    .register_btn {
      width: 370px;
      height: 60px;
      background: rgba(255, 255, 255, 0.75);
      border-radius: 30px;
      font-size: 16px;
      color: #000000;
      margin: 15px auto 0;
      cursor: pointer;
      p {
        margin-left: 15px;
      }
    }
    .arr_more {
      .iconfont {
        color: #fff;
        font-size: 30px;
      }
    }
    .new_content_btm {
      margin: auto;
      width: 60%;
      height: 200px;
      background: rgba(255, 255, 255, 0.75);
      border-radius: 30px 30px 0 0;
    }
  }
  .shop_category_wrap {
    padding: 0 290px;
    box-sizing: border-box;
    position: relative;
    height: 102px;
    opacity: 1; /* 默认不透明 */
    top: 0; /* 默认位置 */
    transition: opacity 0.3s ease, top 0.3s ease; /* 只对 opacity 和 top 过渡 */
    &.top-reached {
      background: #fff;
      position: fixed;
      left: 0;
      top: 30px;
      right: 0;
      z-index: 999;
    }
    .shop_category_main {
      height: 102px;
      cursor: pointer;
      .thumb {
        width: 65px;
        height: 65px;
        margin-right: 10px;
        flex-shrink: 0;
      }
      .content {
        color: #333333;
        h1 {
          font-size: 16px;
          font-weight: 600;
          margin-bottom: 3px;
        }
        p {
          font-size: 14px;
        }
      }
    }
    /deep/ .swiper-button-prev {
      left: 255px;
      background-image: none;
      .iconfont {
        transform: rotate(180deg);
        font-size: 34px;
        display: inline-block;
      }
    }
    /deep/ .swiper-button-next {
      right: 265px;
      background-image: none;
      .iconfont {
        font-size: 34px;
        display: inline-block;
      }
    }
  }
  .colmun_one {
    position: relative;
    background: #fff;
    margin-bottom: 50px;
    .colmun_wrap {
      .img {
        width: 930px;
        height: 600px;
      }
      .content {
        width: 990px;
        height: 600px;
        padding: 92px 310px 0 50px;
        box-sizing: border-box;
        color: #333333;
        .tit {
          font-size: 30px;
        }
        p {
          font-size: 20px;
          line-height: 28px;
          margin: 45px 0 60px;
        }
      }
    }
    /deep/ .swiper-button-prev {
      background: url(../assets/images/colmun_one_prev.png) no-repeat center;
      width: 72px;
      height: 600px;
      top: 0;
      left: 0;
      margin-top: 0;
    }
    /deep/ .swiper-button-next {
      background: url(../assets/images/colmun_one_next.png) no-repeat center;
      width: 72px;
      height: 600px;
      top: 0;
      right: 0;
      margin-top: 0;
    }
  }
  .column_two {
    padding-bottom: 70px;
    .column_list {
      flex-wrap: wrap;
      .column_item {
        width: 665px;
        height: 660px;
        background: #fff;
        margin-right: 30px;
        margin-bottom: 30px;
        padding: 30px 32px;
        box-sizing: border-box;
        color: #333333;
        &:nth-child(2n) {
          margin-right: 0;
        }
        .tit {
          font-size: 30px;
          margin: 25px 0 20px;
          line-height: 35px;
        }
        .txt {
          font-size: 20px;
          line-height: 30px;
        }
      }
    }
    .know_more {
      width: 670px;
      height: 90px;
      background: #fff;
      border-radius: 45px;
      margin: auto;
      font-size: 16px;
      color: #333333;
      padding: 0 30px 0 56px;
      box-sizing: border-box;
      .txt1 {
        font-size: 20px;
        .iconfont {
          font-size: 30px;
          color: #515151;
          margin-right: 16px;
        }
      }
      .txt2 {
        width: 310px;
        height: 45px;
        border-radius: 45px;
        background: #f00139;
        color: #fff;
        cursor: pointer;
      }
    }
  }

  /deep/.el-dialog {
    width: 700px;
    height: 410px;
    background: rgba(255, 255, 255, 0.85);
    border-radius: 30px;
    margin-top: 185px !important;
  }
  /deep/.el-dialog__header {
    height: 92px;
    padding: 0;
    .custom-header {
      height: 100%;
      .logo {
        width: 279px;
        height: 30px;
      }
    }
  }
  /deep/.el-dialog__body {
    padding: 0;
  }
  .custom-dialog {
    .content {
      align-items: flex-start;
      .new_box {
        color: #000000;
        padding-top: 10px;
        box-sizing: border-box;
        .txt {
          margin-bottom: 30px;
          h1 {
            font-size: 20px;
            font-weight: bold;
          }
          p {
            font-size: 16px;
            line-height: 20px;
          }
          &:last-child {
            margin-bottom: 0;
          }
          .mb_5 {
            margin-bottom: 5px;
          }
        }
      }
      .form_box {
        background: none;
      }
    }
    .custom-close {
      position: absolute;
      top: -40px;
      right: 0;
      cursor: pointer;
      i {
        display: inline-block;
        font-size: 30px;
        color: #fff;
      }
    }
  }
}
</style>